(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bundle-product"] && !Shopify.designMode) return;
  try {
    (() => {
    const roots = document.querySelectorAll('[data-bundle-product-root]');
    if (!roots.length) return;

    roots.forEach((root) => {
      if (root.dataset.bound === 'true') return;
      root.dataset.bound = 'true';

      const bundleCheckbox = root.querySelector('[data-bundle-checkbox]');
      if (!bundleCheckbox) return;

      const syncBundlePriceState = () => {
        root.classList.toggle('is-bundle-selected', bundleCheckbox.checked);
      };
      syncBundlePriceState();
      bundleCheckbox.addEventListener('change', syncBundlePriceState);

      const mainProductId = String(root.getAttribute('data-main-product-id') || '');
      const bundleVariantId = Number(root.getAttribute('data-bundle-variant-id') || 0);
      if (!mainProductId || !bundleVariantId) return;

      let isAddingBundle = false;

      document.addEventListener('cart:update', async (event) => {
        const detail = event.detail || {};
        const data = detail.data || {};

        if (data.source !== 'product-form-component') return;
        if (String(data.productId || '') !== mainProductId) return;
        if (!bundleCheckbox.checked || isAddingBundle) return;

        const cart = detail.resource;
        if (cart?.items?.some((item) => Number(item.variant_id) === bundleVariantId)) return;

        isAddingBundle = true;

        try {
          const addResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({ id: bundleVariantId, quantity: 1 }),
          });

          if (!addResponse.ok) return;

          const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
          if (!cartResponse.ok) return;

          const updatedCart = await cartResponse.json();
          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: updatedCart,
                data: {
                  source: 'bundle-product',
                  productId: mainProductId,
                  itemCount: 1,
                },
              },
            })
          );
        } catch (error) {
          console.error('Bundle product add failed', error);
        } finally {
          isAddingBundle = false;
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
